import { render } from "./BulkTransferForm.vue?vue&type=template&id=3330bdd8"
import script from "./BulkTransferForm.vue?vue&type=script&lang=js"
export * from "./BulkTransferForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__